import { render, staticRenderFns } from "./NhapNuocNoiBo.vue?vue&type=template&id=7b764db0"
import script from "./NhapNuocNoiBo.vue?vue&type=script&lang=js"
export * from "./NhapNuocNoiBo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports